import { render, staticRenderFns } from "./CasePrioritySwitcher.vue?vue&type=template&id=ad39c4e2&scoped=true&"
import script from "./CasePrioritySwitcher.vue?vue&type=script&lang=ts&"
export * from "./CasePrioritySwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./CasePrioritySwitcher.vue?vue&type=style&index=0&id=ad39c4e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad39c4e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
